import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { Buffer } from 'buffer';
import Category from '../api/category';
import Template from '../component/common/template';
import Table from '../component/table-category';
import ModalNew from '../component/modalNew';
import { t } from 'i18next';
import Waiting from '../component/waiting';
const { client } = require('../api/auth').default;

const Categories = () => {
    const TableName = 'category';
    const Model = Category;
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState(null);
    const [fileData, setFileData] = useState({});

    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [detail, setDetail] = useState('');
    const [img, setImg] = useState('');
    const [alt, setAlt] = useState('');
    const [list, setList] = useState('["Data1", "Data2"]');

    const [files, setFiles] = useState("");
    const [ext, setExt] = useState("");

    const fetchData = async () => {
        try {
            let cate = await Model.getDataList();
            setCategory(cate);
        } catch (e) {
            console.error(`error get ${TableName}::`, e)
        }

    }

    useEffect(() => {

        localStorage.removeItem(`${TableName}-model-list`)

        fetchData().catch(console.error);

    }, [])


    const deleteData = async (id) => {

        const { data: removeItem } = await Model.remove(id);
        console.log('removeItem::', removeItem);
        if (removeItem.status === 3) {
            console.log(removeItem.message);
            alert('ไม่สามารถลบได้ \n\rเนื่องจากมีสินค้าดึงไปใช้งานแล้ว \n\r-- หากต้องการลบ ต้องเปลี่ยนกลุ่มสินค้าออกจากกลุ่มนี้(ทุกรายการ) --')
        } else {
            let data = category.filter((e) => e.id !== id);
            setCategory(data);

            localStorage.removeItem('category')
            console.log('new data::', category)
        }

    }

    const submitForm = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            localStorage.removeItem('category');
            if (!name) {
                throw new Error('please input name')
            }
            let body = {
                name: name,
                detail: detail,
                img: files,
                img_ext: ext,
                alt: alt,
                list: list
            }


            if (id !== '') {
                console.log('sent update', body)
                let response = await client.patch(`/${TableName}/${id}`, body);
                setId('');
                console.log(id !== '' ? true : false);
                if (response.data.status === 2) {
                    console.log('items update::', TableName)
                    setTimeout(() => {
                        $('body').find('button.close').click();
                        setLoading(false);
                    }, 1000)

                    fetchData().catch(console.error);
                }

            } else {
                let response = await client.post(`/${TableName}`, body);

                //console.log('response::', response.data.data);
                if (response.data.status === 2) {
                    // let newData = category;
                    // newData.push(response.data.data)
                    // setCategory(newData)
                    fetchData().catch(console.error);

                    // console.log('items::', category)
                    setTimeout(() => {
                        $('body').find('button.close').click();
                        setLoading(false);
                    }, 1000)
                }
            }


        } catch (e) {
            console.error('Error:: ', e);
            warning('Error:: ' + e.message);
            $('body').find(`input.${TableName}-name`).focus();
            setLoading(false);
        }
    };


    const warning = (message) => {
        alert(message);
    }


    const handleChange = e => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(e.target.files[0], "UTF-8");
        setExt(e.target.files[0].name.split('.').pop());

        fileReader.onload = e => {
            setFiles(Buffer.from(e.target.result, 'base64'));
        };

        setFileData({
            name: e.target.files[0].name,
            src: URL.createObjectURL(e.target.files[0])
        })
    };

    const closeModal = () => {
        /**
         * Clear data after close modal
         */
        setName('')
        setDetail('')
        setImg('')
        setAlt('')
        setList('["Data1", "Data2"]');
        setFileData({})
        document.getElementById("close-addModalNew").click();
    }

    return (
        <Template >
            <Waiting loading={loading} />
            <ModalNew submitForm={submitForm} ModalName={t('Category')} closeModal={closeModal}>
                <Category.Add
                    TableName={TableName}
                    handleChange={handleChange}
                    id={id}
                    name={name}
                    detail={detail}
                    img={img}
                    alt={alt}
                    list={list}
                    fileData={fileData}

                    setName={setName}
                    setDetail={setDetail}
                    setImg={setImg}
                    setAlt={setAlt}
                    setList={setList}
                />
            </ModalNew>

            <Table

                data={category}
                deleteData={deleteData}

                setId={setId}
                setName={setName}
                setDetail={setDetail}
                setImg={setImg}
                setAlt={setAlt}
                setList={setList}
                setFileData={setFileData}
            />
        </Template>
    );
}

export default Categories;
